import config from "../config";
import Cookies from "js-cookie";

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Source: "bo",
};

export const signin = async (email, password, captchaResponse) => {
  const res = await fetch(config.environment.apiUrl + "/v2/auth/signin", {
    method: "post",
    headers: defaultHeaders,
    body: JSON.stringify({ email, password, captchaResponse }),
  });
  const payload = await res.json();
  return payload.status === "success" ? payload.data : { error: payload.message };
};

export const getRefreshTokens = async () => {
  let token = localStorage.getItem("refreshTokenModeration");
  if (!token) {
    token = Cookies.get("accessTokenModeration");
  }

  const headers = { ...defaultHeaders };
  if (token) {
    headers["Authorization"] = token;
  }

  const res = await fetch(config.environment.apiUrl + "/auth/refresh-token", {
    method: "get",
    headers,
  });

  const payload = await res.json();

  if (payload.status !== "success") {
    localStorage.removeItem("refreshTokenModeration");
    Cookies.remove("accessTokenModeration", { secure: true });
    return null;
  }

  Cookies.set("accessTokenModeration", payload.data.accessToken, { secure: true });
  localStorage.setItem("refreshTokenModeration", payload.data.refreshToken);

  return payload.data;
};
